export module MathUtils {
    export function isNumberBetween(myNumber: number, minValue: number, maxValue: number): boolean {
        if(myNumber < minValue) return false
        if(myNumber > maxValue) return false
        return true
    }

    // Remap a value so it linearly interpolates between `outputStart` and `outputEnd`
    // If `value` === `inputStart` this function returns `outputStart`. If `value` === `inputEnd` it returns `outputEnd`
    // If the value is in between linearly interpolate between the values
    // It's perfectly valid to have start greater than end, in that case the output will decrease depending on `value`
    export function lerp(inputStart: number, inputEnd: number, outputStart: number, outputEnd: number, value: number): number {
        return (value - inputStart) / (inputEnd - inputStart) * (outputEnd - outputStart) + outputStart
    }

    export function calculatePercentage(midNumber: number, lowerBound: number, upperBound: number): number {
        return 100 * (midNumber - lowerBound) / (upperBound - lowerBound)
    }

    export function clampBetweenZeroAndOne(input: number): number {
        return clamp(input, 0, 1)
    }

    export function clamp(input: number, min: number, max: number): number {
        return Math.max(Math.min(input, max), min)
    }
}
